import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  styled,
  TextField,
  Typography
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { firestore } from '../../../../../contexts/FirebaseContext';
import { useSnackbar } from 'notistack';
import { CATEGORY_SERVICE } from '../../../../../constants/categoryService';
import useWallet from '../../../../../hooks/useWallet';
import { getBalanceTypeUser, getSaldoType } from '../../../../../utils/formatWallet';
import useGetUserWallet from '../../../../../hooks/useGetUserWallet';
import useWalletEvents from '../../../../../hooks/useWalletEvents';
import useAuthUsers from '../../../../../hooks/useAuthUsers';

function AbonosCargos({ adminId, data }) {
  const [openDialogAbono, setOpenDialogAbono] = useState(false);
  const [openDialogCargo, setOpenDialogCargo] = useState(false);
  return (
    <Card sx={{ padding: '15px', textAlign: 'center' }}>
      <Box>
        <Typography variant="subtitle1">Aplica abonos y cargos para este usuario</Typography>
        <Divider />
      </Box>
      <Box sx={{ marginTop: '15px', padding: '15px', display: 'flex', justifyContent: 'center', gap: '15px' }}>
        <Button onClick={() => setOpenDialogAbono(true)} variant="contained" color="info">
          Abono
        </Button>
        <DialogAbono open={openDialogAbono} onClose={setOpenDialogAbono} adminId={adminId} dataUser={data} />
        <Button onClick={() => setOpenDialogCargo(true)} variant="contained" color="primary">
          cargo
        </Button>
      </Box>
      <DialogCargo open={openDialogCargo} onClose={setOpenDialogCargo} adminId={adminId} dataUser={data} />
    </Card>
  );
}

export default AbonosCargos;

function DialogAbono({ open, onClose, adminId, dataUser }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { verifyUserNip } = useAuthUsers();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const handleClose = () => {
    onClose(false);
  };

  const { handleWalletEvent, loadingWalletEvent } = useWalletEvents();

  const acceptBono = async (dataForm) => {
    const obj = {
      nameEvent: 'ADD',
      ownerUserID: dataUser.id,
      category_service_id: dataForm.category_service_id,
      amount: dataForm.amount,
      message: dataForm.message,
      reason: 'Abono',
      payment_method: 'ABONO',
      payment_source: 'DAGPACKET',
      rerport_id: '-',
      successFuncts: [reset, handleClose],
      successSnackbar: true
    };

    if (verifyUserNip(dataForm.nip)) {
      handleWalletEvent(obj);
    } else {
      enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Abono</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(acceptBono)}>
          <Box marginBottom="15px">
            <TextField
              type="number"
              fullWidth
              {...register('amount', { required: true })}
              variant="outlined"
              label="Monto"
            />
            {errors.amount && (
              <Typography color="error" fontSize="13px">
                Ingrese el monto
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Tipo de recarga</FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={CATEGORY_SERVICE[0].id}
                name="radio-buttons-group"
                // {...register('category')}
              >
                {CATEGORY_SERVICE.map((category) => (
                  <FormControlLabel
                    key={category.id}
                    {...register('category_service_id')}
                    value={category.id}
                    control={<Radio />}
                    label={category.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
            {errors.message && (
              <Typography color="error" fontSize="13px">
                Ingrese un mensaje
              </Typography>
            )}
          </Box>
          <LoadingButton loading={loadingWalletEvent} fullWidth variant="contained" type="submit">
            Abonar
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function DialogCargo({ open, onClose, adminId, dataUser }) {
  const [loading, setLoading] = useState(false);
  const { cobrar } = useWallet();
  const { enqueueSnackbar } = useSnackbar();
  const { verifyUserNip } = useAuthUsers();
  const { handleWalletEvent, loadingWalletEvent } = useWalletEvents();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const handleClose = () => {
    onClose(false);
  };

  const acceptCargo = async (dataForm) => {
    const obj = {
      nameEvent: 'SUBSTRACT',
      ownerUserID: dataUser.id,
      category_service_id: dataForm.category_service_id,
      amount: dataForm.amount,
      message: dataForm.message,
      reason: 'Cargo',
      payment_method: 'CARGO',
      payment_source: 'DAGPACKET',
      rerport_id: '-',
      successFuncts: [reset, handleClose],
      successSnackbar: true
    };

    if (verifyUserNip(dataForm.nip)) {
      handleWalletEvent(obj);
    } else {
      enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Cargo</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(acceptCargo)}>
          <Box marginBottom="15px">
            <TextField
              type="number"
              fullWidth
              {...register('amount', { required: true })}
              variant="outlined"
              label="Monto"
            />
            {errors.amount && (
              <Typography color="error" fontSize="13px">
                Ingrese el monto
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Tipo de recarga</FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={CATEGORY_SERVICE[0].id}
                name="radio-buttons-group"
                // {...register('category')}
              >
                {CATEGORY_SERVICE.map((category) => (
                  <FormControlLabel
                    key={category.id}
                    {...register('category_service_id')}
                    value={category.id}
                    control={<Radio />}
                    label={category.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
            {errors.message && (
              <Typography color="error" fontSize="13px">
                Ingrese un mensaje
              </Typography>
            )}
          </Box>
          <LoadingButton loading={loadingWalletEvent} fullWidth variant="contained" type="submit">
            Aplicar cargo
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
